var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoupons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6754 19.8316L20.6262 17.8808C21.1885 17.3182 21.5046 16.5553 21.5046 15.7599V7.99867C21.5046 5.23609 19.2651 2.99658 16.5025 2.99658H8.49915C5.73658 2.99658 3.49707 5.23609 3.49707 7.99867V16.002C3.49707 18.7646 5.73658 21.0041 8.49915 21.0041H15.8452C16.9068 21.0041 17.9249 20.5824 18.6754 19.8316V19.8316Z",
    stroke: "#D0D5DD",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.502 21.0045V17.0028C15.502 15.8978 16.3978 15.002 17.5028 15.002H21.5045",
    stroke: "#D0D5DD",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4992 11.9307C12.481 11.9307 12.4635 11.938 12.4508 11.951C12.438 11.964 12.4309 11.9815 12.4312 11.9997C12.4312 12.0277 12.4481 12.053 12.474 12.0636C12.4999 12.0742 12.5297 12.0681 12.5494 12.0482C12.569 12.0282 12.5747 11.9984 12.5637 11.9726C12.5527 11.9469 12.5272 11.9303 12.4992 11.9307",
    stroke: "#D0D5DD",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8693 11.9307C15.8312 11.9307 15.8003 11.9616 15.8003 11.9997C15.8003 12.0378 15.8312 12.0687 15.8693 12.0687C15.9075 12.0687 15.9384 12.0378 15.9384 11.9997C15.9384 11.9616 15.9075 11.9307 15.8693 11.9307",
    stroke: "#D0D5DD",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13007 11.9307C9.11185 11.9307 9.0944 11.938 9.08161 11.951C9.06882 11.964 9.06177 11.9815 9.06204 11.9997C9.06204 12.0277 9.07897 12.053 9.10489 12.0636C9.13081 12.0742 9.16058 12.0681 9.18024 12.0482C9.1999 12.0282 9.20555 11.9984 9.19455 11.9726C9.18355 11.9469 9.15808 11.9303 9.13007 11.9307",
    stroke: "#D0D5DD",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupons);
export default __webpack_public_path__ + "static/media/coupons.847f233ca889605680a775762bc5d384.svg";
export { ForwardRef as ReactComponent };